import { useSelector, useDispatch } from "react-redux";
import { addNote, deleteNote } from "../store/slices/notesSlice";
import { RootState, AppDispatch } from "../store";

export const useNotes = () => {
  const dispatch = useDispatch<AppDispatch>();
  const notes = useSelector((state: RootState) => state.notes.notes);

  //  ideally filter at the endpoint query level
  const getNotesByUser = (username: string) => {
    return notes.filter((note) => note.user === username);
  };

  const getNoteById = (id: string) => {
    return notes.find((note) => note.id === id);
  };

  return {
    notes,
    getNotesByUser,
    getNoteById,
    addNote: (user: string, title: string, description: string) =>
      dispatch(addNote(user, title, description)),
    deleteNote: (id: string) => dispatch(deleteNote(id)),
  };
};
